import { Button, DialogTitle, styled } from "@mui/material";
import { Clear } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { LayerSet } from "types/types";

interface Props {
  layerSet: LayerSet;
  deselectLayerSet: () => void;
}

export function LayerSetDialogTitle(props: Props) {
  const { layerSet, deselectLayerSet } = props;
  const { t } = useTranslation();
  return (
    <StyledDialogTitle variant="h1">
      {layerSet.name}
      <Button
        endIcon={<Clear />}
        variant="close-button"
        onClick={deselectLayerSet}
      >
        {t("label.close")}
      </Button>
    </StyledDialogTitle>
  );
}

const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
